/**
 * Utility functions for managing favicon dynamically
 */

/**
 * Changes the favicon by updating the link element in the document head
 * @param faviconPath - The path to the favicon file (e.g., '/favicon-pos.png')
 */
export const setFavicon = (faviconPath: string): void => {
  // Find existing favicon link elements
  const existingLinks = document.querySelectorAll("link[rel*='icon']")

  // Remove all existing favicon links
  existingLinks.forEach((link) => link.remove())

  // Create new link element
  const link = document.createElement('link')
  link.type = 'image/svg+xml'
  link.rel = 'shortcut icon'
  link.href = faviconPath

  // Add to head
  document.getElementsByTagName('head')[0].appendChild(link)
}

/**
 * Resets the favicon to the default
 */
export const resetFavicon = (): void => {
  setFavicon('/favicon.svg')
}

/**
 * Sets the POS-specific favicon
 */
export const setPOSFavicon = (): void => {
  setFavicon('/favicon-pos.svg')
}
